<div class="site-gutter white-gutter">
    <div class="banner-glide" (mouseenter)="onBannerGlideEnter()" (mouseleave)="onBannerGlideLeave()">

        <div class="glide__track" data-glide-el="track">
            <ul class="glide__slides">
                @for (image of imageList; track $index) {
                    <li class="glide__slide">
                        <picture>
                            <source srcset="{{image.url}}-d.webp, {{image.url}}-d@2x.webp 2x" media="(min-width: 600px)" />
                            <source srcset="{{image.url}}-m.webp, {{image.url}}-m@2x.webp 2x" />
                            <img class="article-hero" src="{{image.url}}-m.webp" alt="{{image.altText}}" />
                        </picture>

                    <!-- @if (activeImage) { } -->
                    </li>
                }
            </ul>
        </div>
        <div class="glide__bullets" data-glide-el="controls[nav]">
            @for (image of imageList; track $index) {
                <button class="glide__bullet" [attr.data-glide-dir]="'='+$index"></button>
            }
        </div>

        @if (showProceedButton) {
            <div class="button-container">
                <div class="button anchor-button" (click)="scrollToExperience()">
                    View the Difference
                    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5005 0.466415V15.8268L17.1567 9.26622L18.561 10.691L9.50049 19.6207L0.438965 10.691L1.84326 9.26622L8.50049 15.8277V0.466415H10.5005Z" fill="black"/>
                    </svg>
                </div>
            </div>
        }
    </div>
</div>